/**
 * LocalStorage Utility
 * 
 * 統一的 localStorage 管理工具
 * 支援錯誤處理和 debounce
 */

/**
 * 安全地獲取 localStorage 項目
 */
export const getItem = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    if (item === null) {
      return defaultValue;
    }
    return JSON.parse(item);
  } catch (error) {
    console.error(`Failed to get localStorage item ${key}:`, error);
    return defaultValue;
  }
};

/**
 * 安全地設置 localStorage 項目
 */
export const setItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.error(`Failed to set localStorage item ${key}:`, error);
    
    // 處理 quota exceeded 錯誤
    if (error.name === 'QuotaExceededError') {
      console.warn('LocalStorage quota exceeded. Attempting to clear old data...');
      // 可以嘗試清理舊資料或提示用戶
    }
    
    return false;
  }
};

/**
 * 安全地刪除 localStorage 項目
 */
export const removeItem = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error(`Failed to remove localStorage item ${key}:`, error);
    return false;
  }
};

/**
 * 清空所有 localStorage（謹慎使用）
 */
export const clear = () => {
  try {
    localStorage.clear();
    return true;
  } catch (error) {
    console.error('Failed to clear localStorage:', error);
    return false;
  }
};

/**
 * Debounce 版本的 setItem
 * 用於減少寫入頻率
 */
let debounceTimers = {};

export const setItemDebounced = (key, value, delay = 300) => {
  // 清除之前的定時器
  if (debounceTimers[key]) {
    clearTimeout(debounceTimers[key]);
  }

  // 設置新的定時器
  debounceTimers[key] = setTimeout(() => {
    setItem(key, value);
    delete debounceTimers[key];
  }, delay);
};

/**
 * 清理所有 debounce 定時器
 */
export const flushDebounced = () => {
  Object.keys(debounceTimers).forEach(key => {
    clearTimeout(debounceTimers[key]);
  });
  debounceTimers = {};
};

